<template>
  <div class="page-container">
    <van-nav-bar
      left-text="返回"
      left-arrow
      @click-left="closePage"
      title="路线详情"
      @click-right="onClickRight"
    />
    <van-cell-group>
      <van-cell title="路线编号">
        <template #value>
          <span class="routeCode">{{ detailInfo.routeCode }}</span>
          <van-tag type="success">执行中</van-tag>
        </template>
      </van-cell>
      <van-cell
        title="路线有效期"
        :value="detailInfo.validStartTime + ' 至 ' + detailInfo.validEndTime"
      />
    </van-cell-group>
    <van-cell-group>
      <van-cell
        title="委托人"
        :value="detailInfo.trustorCompanyName"
      ></van-cell>
      <van-cell
        title="承运人"
        :value="detailInfo.carrierCompanyName"
      ></van-cell>
    </van-cell-group>
    <van-cell-group>
      <van-cell class="logistics">
        <template #title>
          <div class="logistics_type">
            <van-icon name="location-o" />
            <div>起</div>
          </div>
        </template>
        <template #value>
          <div class="logistics_info">
            <div class="uname">
              <span>{{ detailInfo.senderInfo.contactsUserName }}</span>
              <a
                :href="`tel:${detailInfo.senderInfo.contactsUserMobile}`"
                v-if="fromType == 'weixin'"
              >
                <van-icon name="phone-circle-o" class="tel-icon" size="30" />
              </a>
              <a v-else>
                <van-icon
                  @click="goMobile(detailInfo.senderInfo.contactsUserMobile)"
                  name="phone-circle-o"
                  class="tel-icon"
                  size="30"
                />
              </a>
            </div>
            <div class="add">{{ detailInfo.senderInfo.companyName }}</div>
            <div class="uname">
              {{ detailInfo.senderInfo.detailAddress
              }}{{ detailInfo.senderInfo.streetName }}
            </div>
          </div>
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group>
      <van-cell class="logistics">
        <template #title>
          <div class="logistics_type">
            <van-icon name="location-o" />
            <div>终</div>
          </div>
        </template>
        <template #value>
          <div class="logistics_info">
            <div class="uname">
              <span>{{ detailInfo.receiveInfo.contactsUserName }}</span>
              <a
                :href="`tel:${detailInfo.receiveInfo.contactsUserMobile}`"
                v-if="fromType == 'weixin'"
              >
                <van-icon name="phone-circle-o" class="tel-icon" size="30" />
              </a>
              <a v-else>
                <van-icon
                  @click="goMobile(detailInfo.receiveInfo.contactsUserMobile)"
                  name="phone-circle-o"
                  class="tel-icon"
                  size="30"
                />
              </a>
            </div>
            <div class="add">{{ detailInfo.receiveInfo.companyName }}</div>
            <div class="uname">
              {{ detailInfo.receiveInfo.detailAddress
              }}{{ detailInfo.receiveInfo.streetName }}
            </div>
          </div>
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group>
      <van-cell
        title="货物信息"
        :value="
          detailInfo.goodsInfo.goodsName +
          ' | ' +
          detailInfo.goodsInfo.weight +
          detailInfo.goodsInfo.weightUnitName +
          ' | ' +
          detailInfo.goodsInfo.volume +
          detailInfo.goodsInfo.volumeUnitName +
          ' | ' +
          detailInfo.goodsInfo.quantity +
          detailInfo.goodsInfo.quantityUnitName
        "
      ></van-cell>
    </van-cell-group>
    <van-cell-group>
      <van-cell
        title="计价方式"
        :value="detailInfo.valuationModeDesc"
      ></van-cell>
    </van-cell-group>
    <van-cell-group>
      <van-field
        :required="detailInfo.valuationMode == '1131000'"
        type="number"
        @input="updateRouteModifyFreight"
        v-model="detailInfo.stowageWeight"
        placeholder="请输入配载重量"
      >
        <template #label>配载重量</template>
        <template #button>{{ detailInfo.goodsInfo.weightUnitName }}</template>
      </van-field>
      <van-field
        :required="detailInfo.valuationMode == '1131010'"
        type="number"
        @input="updateRouteModifyFreight"
        v-model="detailInfo.stowageVolume"
        placeholder="请输入配载体积"
      >
        <template #label>配载体积</template>
        <template #button>{{ detailInfo.goodsInfo.volumeUnitName }}</template>
      </van-field>
      <van-field
        :required="detailInfo.valuationMode == '1131020'"
        type="number"
        @input="updateRouteModifyFreight"
        v-model="detailInfo.stowageQuantity"
        placeholder="请输入配载数量"
      >
        <template #label>配载数量</template>
        <template #button>{{ detailInfo.goodsInfo.quantityUnitName }}</template>
      </van-field>
    </van-cell-group>
    <van-cell-group>
      <van-field
        v-model="detailInfo.deliverDate"
        placeholder="请选择发货时间"
        @click="DeliverTimeHandle(1)"
      >
        <template #label><span style="color: red">*</span> 发货时间</template>
      </van-field>
      <van-field
        v-model="detailInfo.arrivalDate"
        placeholder="请选择收货时间"
        @click="DeliverTimeHandle(2)"
      >
        <template #label
          ><span style="color: red">*</span> 收货时间</template
        ></van-field
      >
    </van-cell-group>
    <van-cell-group class="routeCheck">
      <van-cell title="回单要求">
        <template #value>
          <van-checkbox-group
            v-model="detailInfo.podType"
            direction="horizontal"
            ref="checkboxGroup"
            style="float: right"
            disabled
          >
            <van-checkbox name="2001010">货物托运单</van-checkbox>
            <van-checkbox name="2001000" style="margin-right: -8px"
              >发货单（客户文件）</van-checkbox
            >
          </van-checkbox-group>
        </template>
      </van-cell>
      <van-cell title="发票要求" class="routeCheck">
        <template #value>
          <van-checkbox
            disabled
            style="float: right"
            name="1031010"
            v-model="detailInfo.transportationInvoices"
            >开票</van-checkbox
          >
        </template>
      </van-cell>
      <van-cell title="路线备注" :value="detailInfo.remark"></van-cell>
    </van-cell-group>
    <van-cell-group>
      <van-cell
        title="选择载具"
        is-link
        :value="detailInfo.vehicleCode ? detailInfo.vehicleCode : '请选择'"
        @click="chooseVh"
      ></van-cell>
      <van-cell
        title="选择司机"
        is-link
        @click="chooseDr"
        :value="detailInfo.driverName ? detailInfo.driverName : '请选择'"
      ></van-cell>
      <van-cell
        title="结算对象"
        is-link
        :value="
          detailInfo.settlementPersonName
            ? detailInfo.settlementPersonName
            : '选择结算对象'
        "
        @click="openPicker"
      ></van-cell>
      <van-field
        v-model="detailInfo.suremark"
        label="备注"
        placeholder="请输入"
        input-align="right"
      >
        <template #button> </template
      ></van-field>
    </van-cell-group>
    <!-- <van-cell-group>
      <van-cell title="现场装运单" is-link value="内容"></van-cell>
      <van-cell
        title="提货单"
        is-link
        arrow-direction="down"
        value=""
      ></van-cell>
    </van-cell-group> isRequired-->
    <van-collapse v-model="activeNames" @change="$forceUpdate()">
      <van-collapse-item
        v-for="item in detailInfo.customDocumentPhotos"
        :key="item.seq"
        :title="item.field"
        :name="item.seq"
        :required="item.isRequired"
      >
        <!-- <div></div> -->
        <van-uploader v-model="item.fileList" :after-read="afterRead" />
      </van-collapse-item>
      <!-- :disabled="isWx" -->
      <!-- <van-collapse-item title="提货单" name="2"
        ><van-uploader v-model="fileList2" :after-read="afterRead" multiple
      /></van-collapse-item> -->
    </van-collapse>
    <van-cell-group>
      <van-cell
        title="运费合计"
        is-link
        value="内容"
        @click="showPrice = !showPrice"
      >
        <template #value>
          <span class="price">￥{{ totalFee }}</span>
        </template>
      </van-cell>
    </van-cell-group>
  </div>
  <div class="submit">
    <van-button
      type="primary"
      :disabled="clickDisable"
      block
      @click="submitForm"
      >确认,并生成运单</van-button
    >
  </div>

  <van-overlay :show="detailInfo.isDeliverTimeShow">
    <div class="datetime-picke" @click.stop>
      <van-datetime-picker
        v-model="chooseData"
        type="datetime"
        title="选择年月日小时"
        :min-date="minDate"
        :max-date="maxDate"
        value-format="yyyy-MM-dd HH:mm"
        @confirm="onconfirm1"
        @cancel="detailInfo.isDeliverTimeShow = false"
        :formatter="formatter"
      />
    </div>
  </van-overlay>
  <van-overlay :show="vehicleshow" v-if="vehicleshow">
    <vehiceChoose
      :vehiclechecked="detailInfo.vehicleId"
      @closeVehicle="closeVehicle"
    ></vehiceChoose>
  </van-overlay>
  <van-overlay :show="drivershow" v-if="drivershow">
    <driverChoose
      :driverchecked="detailInfo.driverId"
      @closeDriver="closeDriver"
    ></driverChoose>
  </van-overlay>
  <van-popup v-model:show="show" round position="bottom">
    <van-button block>拍照</van-button>
    <van-button block>手机相册中选择</van-button>
    <van-button block>取消</van-button>
  </van-popup>
  <van-popup
    v-model:show="showPrice"
    :close-on-click-overlay="false"
    round
    position="bottom"
  >
    <van-cell-group inset>
      <van-cell title="修改运费金额" />
      <van-field
        v-model="money1"
        label="现付"
        error
        type="number"
        @blur="inputmoney('money1')"
        placeholder="请输入金额"
        input-align="right"
      >
        <template #button>元</template>
      </van-field>
      <van-field
        v-model="money2"
        label="到付"
        error
        type="number"
        @blur="inputmoney('money2')"
        placeholder="请输入金额"
        input-align="right"
      >
        <template #button>元</template>
      </van-field>
      <van-field
        v-model="money3"
        label="回付"
        error
        type="number"
        @blur="inputmoney('money3')"
        placeholder="请输入金额"
        input-align="right"
      >
        <template #button>元</template>
      </van-field>
      <van-field
        v-model="money4"
        label="月结"
        error
        @blur="inputmoney('money4')"
        placeholder="请输入金额"
        input-align="right"
      >
        <template #button>元</template>
      </van-field>
    </van-cell-group>
    <van-button block @click="submitFee">确定</van-button>
  </van-popup>
  <van-popup v-model:show="showPicker" round position="bottom">
    <van-radio-group v-model="settlementChecked">
      <van-cell-group>
        <div v-for="item in list" :key="item.settlementTargetId">
          <van-cell clickable @click="changeCheck(item)">
            <van-row>
              <van-col :span="8">
                <span v-if="item.settlementTargetType == 2741010">司机</span>
                <span v-else-if="item.settlementTargetType == 2741020"
                  >车主</span
                >
                <span v-else-if="item.settlementTargetType == 2741030"
                  >车队长</span
                >
              </van-col>
              <van-col :span="8">{{
                item.practicalSettlementTargetName
              }}</van-col>
            </van-row>
            <template #right-icon>
              <van-radio :name="item.settlementTargetId" />
            </template>
          </van-cell>
          <div class="divider"></div>
        </div>
      </van-cell-group>
    </van-radio-group>
  </van-popup>
</template>

<script>
import { reactive, defineComponent, ref } from "vue";
import vehiceChoose from "../dialog/vehicleChoose.vue";
import driverChoose from "../dialog/driverChoose.vue";
import {
  NavBar,
  Button,
  Icon,
  Col,
  Row,
  Cell,
  CellGroup,
  Tag,
  Field,
  DatetimePicker,
  Overlay,
  Checkbox,
  CheckboxGroup,
  ShareSheet,
  Popup,
  Collapse,
  CollapseItem,
  Uploader,
  Toast,
  RadioGroup,
  Radio,
} from "vant";
import http from "../../api/dashboard";
import { uploadFile } from "../../api/index.js";
import timeReg from "@/common/utils/timeReg.js";
import flutter from "@/common/utils/flutter.js";
import map from "@/common/utils/map.js";
import Cookies from "js-cookie";
import wx from "weixin-js-sdk";
export default defineComponent({
  name: "routeDetail",
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Col.name]: Col,
    [Row.name]: Row,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tag.name]: Tag,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [Overlay.name]: Overlay,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [NavBar.name]: NavBar,
    [ShareSheet.name]: ShareSheet,
    [Popup.name]: Popup,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Uploader.name]: Uploader,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    vehiceChoose: vehiceChoose,
    driverChoose: driverChoose,
  },
  setup() {
    const detailInfo = ref({
      routeCode: "",
      validStartTime: "",
      validEndTime: "",
      trustorCompanyName: "", //托运人
      trustCompanyId: "", //托运人ID
      carrierCompanyName: "", //承运人
      carryCompanyId: "", //承运人ID，
      senderInfo: {},
      receiveInfo: {},
      goodsInfo: {},
      sendName: "", //发货联系人
      sendMobile: "", //发货联系人手机号
      sendCompanyName: "", //发货公司
      sendAddressStream: "", //发货地址
      receiverName: "", //收货联系人
      receiverMobile: "", //收货联系人手机号
      receiptCompanyName: "", //收货公司
      receiverAddressStream: "", //收货地址
      cargo: "", //货物信息
      stowageWeight: "", //配载重量
      stowageVolume: "", //配载体积
      valuationModeDesc: "", //计价方式
      isDeliverTimeShow: false,
      deliverTime: "", //发货时间
      receivingTime: "", //收  货时间
      podType: [], //回单要求
    });
    var chooseData = ref(new Date());
    var timeType = ref("");

    const onClickLeft = () => {
      window["backToPrimary"].postMessage("");
    };
    const goMobile = (mobile) => {
      var mobileParam = { mobileStr: mobile };
      window["ringUpAction"].postMessage(JSON.stringify(mobileParam));
    };
    const onClickRight = () => console.log("按钮");
    const vehicleshow = ref(false);
    const drivershow = ref(false);
    const show = ref(false);
    const showPrice = ref(false);
    const showPicker = ref(false);
    return {
      detailInfo,
      minDate: new Date(),
      maxDate: new Date(2099, 12, 31),
      onClickLeft,
      onClickRight,
      vehicleshow,
      drivershow,
      show,
      activeNames: [],
      showPrice,
      user: {},
      clickDisable: false,
      chooseData: null,
      timeType,
      goMobile,
      money1: ref("0.00"),
      money2: ref("0.00"),
      money3: ref("0.00"),
      money4: ref("0.00"),
      totalFee: ref("0.00"),
      showPicker,
      settlementChecked: ref(""),
      list: [],
      fileIndex: 0,
      isWx: false,
      waybillSettlementTargetType: "",
      fromType: "",
    };
  },
  created() {
    var ua = window.navigator.userAgent.toLowerCase();
    let that = this;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //微信环境下
      this.fromType = "weixin";
    } else {
      let result;
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        this.fromType = "ios";
      } else {
        this.fromType = "android";
      }
    }
  },
  methods: {
    openPicker() {
      if (this.detailInfo.driverId || this.detailInfo.vehicleId) {
        this.showPicker = true;
      } else {
        Toast("请选择司机和载具");
      }
    },
    onConfirm() {},
    changeCheck(val) {
      this.detailInfo.settlementPersonId = val.settlementTargetId;
      this.detailInfo.settlementPersonName = val.settlementTargetName;
      this.detailInfo.settlementType = val.settlementTargetType;
      this.showPicker = false;
    },
    submitFee() {
      var allFee =
        Number(this.money1 ? this.money1 : 0) +
        Number(this.money2 ? this.money2 : 0) +
        Number(this.money3 ? this.money3 : 0) +
        Number(this.money4 ? this.money4 : 0);
      if (allFee != Number(this.detailInfo.totalFee)) {
        Toast.fail("修改金额必须等于总金额");
        return;
      } else {
        this.showPrice = false;
      }
    },
    toPrice(num) {
      num = parseFloat((num + "").replace(/(\.\d{2})\d+$/, "$1"))
        .toFixed(2)
        .toString()
        .split(".");
      num[0] = num[0].replace(new RegExp("(\\d)(?=(\\d{3})+$)", "ig"), "$1,");
      return num.join(".");
    },
    inputmoney(val) {
      if (this[val] && !isNaN(this[val])) {
        var money = Number(this[val]);
        this[val] = money.toFixed(2);
      } else {
        this[val] = "0.00";
      }
    },
    DeliverTimeHandle(type) {
      if (type == 1) {
        this.chooseData = reactive(new Date(this.detailInfo.deliverDate));
      } else {
        this.chooseData = reactive(new Date(this.detailInfo.arrivalDate));
      }
      this.timeType = type;
      this.detailInfo.isDeliverTimeShow = reactive(true);
    },
    onconfirm1(val) {
      if (this.timeType == 1) {
        this.detailInfo.deliverDate = reactive(timeReg.formatDateTime(val));
      } else {
        this.detailInfo.arrivalDate = reactive(timeReg.formatDateTime(val));
      }
      this.detailInfo.isDeliverTimeShow = reactive(false);
    },
    submitForm() {
      var that = this;
      if (
        (!this.detailInfo.stowageWeight &&
          this.detailInfo.valuationMode == "1131000") ||
        (!this.detailInfo.stowageVolume &&
          this.detailInfo.valuationMode == "1131010") ||
        (!this.detailInfo.stowageQuantity &&
          this.detailInfo.valuationMode == "1131020")
      ) {
        Toast.fail("请完善信息");
        return;
      }

      if (
        this.detailInfo.deliverDate &&
        this.detailInfo.arrivalDate &&
        this.detailInfo.deliverDate > this.detailInfo.arrivalDate
      ) {
        Toast.fail("发货时间必须早于收货时间");
        return;
      }

      var goodsInfo = this.detailInfo.goodsInfo;
      goodsInfo.weight = this.detailInfo.stowageWeight;
      goodsInfo.volume = this.detailInfo.stowageVolume;
      goodsInfo.quantity = this.detailInfo.stowageQuantity;
      var saveDispatchPaymentParam =
        this.detailInfo.dispatchPaymentScheduleParamList;
      saveDispatchPaymentParam.forEach((item) => {
        delete item.voucherTypeName;
        delete item.priceRatio;
      });
      saveDispatchPaymentParam.forEach((item) => {
        switch (item.paymentMode) {
          case 1021000:
            item.money = this.money1;
            break;
          case 1021040:
            item.money = this.money2;
            break;
          case 1021020:
            item.money = this.money3;
            break;
          case 1021030:
            item.money = this.money4;
            break;
          default:
            break;
        }
      });
      var arrOtherPhotos = [];
      var isPhoto = false;
      this.detailInfo.customDocumentPhotos.forEach((item) => {
        if (item.isRequired && item.fileList.length == 0) {
          isPhoto = true;
        }
        item.fileList.forEach((item2) => {
          if (item2.fileID) {
            arrOtherPhotos.push({
              bizType: 1,
              fileId: item2.fileID,
              fileName: item.field,
              fileSeqNo: item.seq,
              photoCategory: 4560010,
              fileType: item.type,
            });
          }
        });
      });
      if (isPhoto) {
        Toast.fail("请上传图片");
        return;
      }
      if (!this.detailInfo.driverId) {
        Toast.fail("请选择驾驶员");
        return;
      }
      if (!this.detailInfo.settlementPersonId) {
        Toast.fail("请选择结算对象");
        return;
      }
      if (!this.detailInfo.vehicleId) {
        Toast.fail("请选择载具");
        return;
      }
      if (that.clickDisable) {
        Toast.fail("请勿重复点击");
        return;
      }
      this.clickDisable = reactive(true);
      var param = {
        arrOtherPhotos: arrOtherPhotos,
        deliverDate: this.detailInfo.deliverDate,
        arrivalDate: this.detailInfo.arrivalDate,
        dispatchBatchRemark: this.detailInfo.suremark,
        goodsInfo: goodsInfo,
        routeId: this.$route.params.Id,
        vehicleParam: {
          masterDriverId: this.detailInfo.driverId,
          settlementPersonId: this.detailInfo.settlementPersonId,
          settlementPersonName: this.detailInfo.settlementPersonName,
          settlementType: this.detailInfo.settlementType,
          // slaveDriverId: "",
          vehicleCode: this.detailInfo.vehicleCode,
          vehicleId: this.detailInfo.vehicleId,
        },
        saveDispatchPaymentParam: saveDispatchPaymentParam,
      };
      http.createOrderBatch(param).then((res) => {
        if (res) {
          Toast.success("创建成功");
          that.closePage(true);
        } else {
          that.clickDisable = reactive(false);
        }
      });
    },
    beforeRead(index) {
      alert("进来了1");
      var ua = window.navigator.userAgent.toLowerCase();
      let that = this;
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境下
        flutter.getFlutterData();
      } else {
        alert("进来了2");
        this.fileIndex = index;
        flutter.getFlutterData();
      }
    },
    closePage(flag) {
      var ua = window.navigator.userAgent.toLowerCase();
      let that = this;
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境下
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            // 小程序环境下逻辑
            wx.miniProgram.navigateBack();
          } else {
            //非小程序环境下逻辑
            wx.call("closeWindow");
          }
        });
      } else {
        let result;
        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {
          if (flag == true) {
            window["dispatchDataCreateSuccess"].postMessage("");
          } else {
            window["backToPrimary"].postMessage("");
          }
          // result =
          //   window.webkit.messageHandlers["jsonPageFinish"].postMessage();
        } else {
          if (flag == true) {
            window["dispatchDataCreateSuccess"].postMessage("");
          } else {
            window["backToPrimary"].postMessage("");
          }

          // result = window.android["jsonPageFinish"]();
        }
      }
    },
    // 退出h5页面到终端
    // backToTerminal() {
    //   var me = this;
    //   if (window.CommonApp.isWXMiniProgram) {
    //     mui.back();
    //   } else if (mui.os.ios) {
    //     me.setupWebViewJavascriptBridge(function (bridge) {
    //       bridge.callHandler(
    //         "jsonPageFinish",
    //         {},
    //         function responseCallback(responseData) {}
    //       );
    //     });
    //   } else if (mui.os.android) {
    //     myObj.jsonPageFinish();
    //   }
    // },
    getDeatil() {
      var that = this;
      http.getRouteDetail({ id: this.$route.params.Id }).then((res) => {
        var podType = [];
        res.data.podTypeList = res.data.podTypeList ? res.data.podTypeList : [];
        res.data.podTypeList.forEach((item) => {
          podType.push(item.key);
        });
        var feeList = [
          {
            paymentMode: 1021000,
            money: 0.0,
          },
          {
            paymentMode: 1021040,
            money: 0.0,
          },
          {
            paymentMode: 1021020,
            money: 0.0,
          },
          {
            paymentMode: 1021030,
            money: 0.0,
          },
        ];
        res.data.customDocumentPhotos = res.data.customDocumentPhotos
          ? res.data.customDocumentPhotos
          : [];
        res.data.customDocumentPhotos.forEach((item) => {
          item.fileList = [];
        });
        res.data.dispatchPaymentScheduleParamList = res.data
          .dispatchPaymentScheduleParamList
          ? res.data.dispatchPaymentScheduleParamList
          : [];
        var totalFee = 0;
        res.data.dispatchPaymentScheduleParamList.forEach((item) => {
          for (let i in feeList) {
            if (feeList[i].paymentMode == item.paymentMode) {
              feeList[i] = item;
              break;
            }
          }
          item.money = item.money ? item.money : 0;
          totalFee += item.money;
          switch (item.paymentMode) {
            case 1021000:
              this.money1 = item.money.toFixed(2);
              break;
            case 1021040:
              this.money2 = item.money.toFixed(2);
              break;
            case 1021020:
              this.money3 = item.money.toFixed(2);
              break;
            case 1021030:
              this.money4 = item.money.toFixed(2);
              break;
            default:
              break;
          }
        });
        res.data.totalFee = totalFee;
        that.totalFee = reactive(that.toPrice(totalFee));
        res.data.dispatchPaymentScheduleParamList = feeList;
        res.data.podType = podType;
        // if (res.data.tonnage) {
        //   res.data.stowageWeight = res.data.tonnage;
        // }
        that.detailInfo = res.data;
        that.detailInfo.stowageWeight = that.detailInfo.goodsInfo.weight;
        that.detailInfo.stowageVolume = that.detailInfo.goodsInfo.volume;
        that.detailInfo.stowageQuantity = that.detailInfo.goodsInfo.quantity;
        switch (that.detailInfo.valuationMode) {
          case 1131000:
            that.detailInfo.stowageWeight = that.detailInfo.tonnage;
            break;
          case 1131010:
            that.detailInfo.stowageVolume = that.detailInfo.tonnage;
            break;
          case 1131020:
            that.detailInfo.stowageQuantity = that.detailInfo.tonnage;
            break;
          default:
            break;
        }
        that.updateRouteModifyFreight();

        if (new Date(res.data.validEndTime) < new Date()) {
          Toast.fail({
            forbidClick: true,
            message: "路线已过期,无法生成运单",
          });
          that.clickDisable = reactive(true);
        }
      });
    },
    updateRouteModifyFreight() {
      var that = this;
      var param = {
        quantity: this.detailInfo.stowageQuantity,
        routeId: this.$route.params.Id,
        volume: this.detailInfo.stowageVolume,
        weight: this.detailInfo.stowageWeight,
      };
      http.updateRouteModifyFreight(param).then((res) => {
        if (
          res.data.paymenScheduleParamList &&
          res.data.paymenScheduleParamList.length > 0
        ) {
          var paymenScheduleParamList = res.data.paymenScheduleParamList;
          that.detailInfo.dispatchPaymentScheduleParamList.forEach((item) => {
            var isHave = true;
            for (var i in paymenScheduleParamList) {
              if (item.paymentMode == paymenScheduleParamList[i].paymentMode) {
                item.money = paymenScheduleParamList[i].money;
                isHave = false;
              }
            }
            if (isHave) {
              item.money = 0;
            }
            switch (item.paymentMode) {
              case 1021000:
                that.money1 = item.money.toFixed(2);
                break;
              case 1021040:
                that.money2 = item.money.toFixed(2);
                break;
              case 1021020:
                that.money3 = item.money.toFixed(2);
                break;
              case 1021030:
                that.money4 = item.money.toFixed(2);
                break;
              default:
                break;
            }
          });
        }
        this.detailInfo.totalFee = res.data.totalPrice;
        this.totalFee = res.data.totalPrice;
        that.$forceUpdate();
        that.getVehicleList();
      });
    },
    getVehicleList() {
      var that = this;
      http
        .getVehicleList({
          pageNum: "1",
          pageSize: "2",
        })
        .then((res) => {
          if (res.data.list && res.data.list.length == 1) {
            var vehicleInfo =res.data.list[0]
            var vehicleCode = vehicleInfo.vehicleCode;
            var driverInfo = vehicleInfo.defaultDriverList
              ? vehicleInfo.defaultDriverList.length > 0
                ? vehicleInfo.defaultDriverList[0]
                : null
              : null;
            that.closeVehicle(vehicleInfo.vehicleId, vehicleCode, driverInfo);
          }
        });
    },
    chooseVh() {
      this.vehicleshow = true;
    },
    chooseDr() {
      this.drivershow = true;
    },
    closeVehicle(val, vehicleCode, driverInfo) {
      if (val) {
        this.detailInfo.vehicleCode = vehicleCode;
        this.detailInfo.vehicleId = val;
        if (driverInfo) {
          this.detailInfo.driverId = reactive(driverInfo.driverId);
          this.detailInfo.driverName = reactive(driverInfo.name);
        }
        this.getSettlement();
      }
      this.vehicleshow = reactive(false);
      this.$forceUpdate();
    },
    getSettlement() {
      var param = {
        chiefDriverId: this.detailInfo.driverId,
        // "deputyDriverId": "",
        vehiclesId: this.detailInfo.vehicleId,
      };
      http.listSettlementObject(param).then((res) => {
        this.list = reactive(res.data);
        for (var i in this.list) {
          if (
            this.list[i].settlementTargetType ==
            this.waybillSettlementTargetType
          ) {
            this.changeCheck(this.list[i]);
            return;
          }
        }
      });
    },
    closeDriver(val, name) {
      if (val) {
        this.detailInfo.driverName = reactive(name);
        this.detailInfo.driverId = reactive(val);
        this.getSettlement();
      }
      this.drivershow = reactive(false);
    },
    getUserInfo() {
      http
        .queryUserByMobile({ mobile: this.$route.params.mobile })
        .then((res) => {
          localStorage.setItem("user", JSON.stringify(res.data));
          this.user = res.data;
          this.waybillSettlementTargetType =
            res.data.companyInfo.companySetting.waybillSettlementTargetType;
        });
    },
    async afterRead(file) {
      var that = this;
      file.status = "uploading";
      file.message = "上传中...";
      const formdata = new FormData();
      formdata.append("file", file.file);
      formdata.append("uploadType", "watermarkTextUpload");
      formdata.append("source", "OTHERS");
      var address = "";
      if (localStorage.getItem("address")) {
        address = JSON.parse(localStorage.getItem("address"));
      }
      var watermarkText = null;
      var text1 = "上传用户：";
      that.user.companyInfo.companyName +
        " " +
        that.user.userName +
        "(" +
        that.user.mobile +
        ")\n";
      var text3 = "上传时间：" + timeReg.getNowFormatDate(new Date());
      var text2 = "";
      if (address) {
        text2 =
          "上传位置：" +
          address.formattedAddress +
          " (" +
          address.position.lng +
          "," +
          address.position.lat +
          ")\n";
      } else {
        text2 =
          that.detailInfo.receiveInfo.detailAddress +
          that.detailInfo.receiveInfo.streetName +
          "\n";
      }
      watermarkText = text1 + text2 + text3;
      formdata.append("watermarkText", watermarkText);
      // formdata.append("agentCode", "demo2");
      // formdata.append("source", "OTHERS");
      const res = await uploadFile(formdata);
      if (res.data && res.data.code === "200") {
        Object.assign(file, file, res.data);
        file.status = "done";
        file.message = "上传成功";
      } else {
        file.status = "failed";
        file.message = "上传失败";
      }
    },
    // callJS(value) {
    //   //  this.value=value;
    //   Toast(value);
    // },
  },
  mounted() {
    // window.callJS = (e) => {
    //   this.callJS(e);
    // };
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //微信环境下
      this.isWx = true;
    } else {
      let result;
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        this.isWx = false;
      } else {
        this.isWx = true;
      }
    }
    flutter.postImageInfoToJS();
    map.getLocation();
    localStorage.setItem("token", this.$route.params.session);
    // Cookies.set("SESSION", this.$route.params.session);
    let cookies = Cookies.get() ? Cookies.get() : {};

    for (var i in cookies) {
      Cookies.remove(i, { path: "/" });
      Cookies.remove(i, { path: "" });
    }
    Cookies.remove("SESSION", { path: "/" });
    // Cookies.set("SESSION", this.$route.params.session);
    this.getDeatil();
    this.getUserInfo();
  },
});
</script>

<style lang="less" scoped="scoped">
.routeCheck {
  /deep/ .van-checkbox__icon--disabled .van-icon {
    color: var(--van-white);
    background-color: var(--van-checkbox-checked-icon-color);
    border-color: var(--van-checkbox-checked-icon-color);
  }
  /deep/ .van-checkbox__label--disabled {
    color: var(--van-checkbox-label-color);
  }
}

/deep/ .van-nav-bar__content {
  background-color: rgba(12, 38, 55, 1);
  color: white;
}
/deep/ .van-nav-bar__title {
  color: white;
}
/deep/ .van-nav-bar__text {
  color: var(--van-white);
}
/deep/ .van-icon-arrow-left:before {
  color: var(--van-white);
}
/deep/ .van-uploader__preview-image {
  width: 77px;
  height: 77px;
}
/deep/ .van-uploader__upload {
  width: 77px;
  height: 77px;
}
.submit {
  position: sticky;
  padding: 10px;
  bottom: 0px;
}
.price {
  color: var(--van-field-input-error-text-color);
}
.van-cell-group + .van-cell-group {
  margin-top: 10px;
}

.van-cell-group /deep/ .van-cell__title {
  flex: inherit;
}

.van-cell-group /deep/ .van-field__control {
  text-align: right;
}

.logistics {
  align-items: center;
}

.logistics_type {
  color: rgba(25, 137, 250, 1);
  text-align: center;
  margin-right: 15px;

  .van-icon {
    font-size: 24px;
  }
}
.logistics_info {
  text-align: left;
  color: #333;

  .uname {
    display: flex;
    justify-content: space-between;
    margin-bottom: 3px;

    span {
      font-size: 16px;
    }

    .van-icon {
      color: rgba(25, 137, 250, 1);
      font-size: 18px;
    }
  }
}
.routeCode {
  margin-right: 10px;
}

.datetime-picke {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
